import React from 'react'

import { createValidIcon } from '@ui/icons/utils/type-helper'

export const TimeIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M6.83025 2.35724C7.18525 2.78031 7.13006 3.41107 6.70699 3.76607L3.64281 6.33722C3.21974 6.69222 2.58898 6.63704 2.23398 6.21396C1.87898 5.79089 1.93416 5.16013 2.35724 4.80513L5.42141 2.23398C5.84449 1.87898 6.47524 1.93416 6.83025 2.35724ZM17.1734 2.35724C17.5284 1.93416 18.1592 1.87898 18.5823 2.23398L21.6464 4.80513C22.0695 5.16013 22.1247 5.79089 21.7697 6.21396C21.4147 6.63704 20.7839 6.69222 20.3609 6.33722L17.2967 3.76607C16.8736 3.41107 16.8184 2.78031 17.1734 2.35724ZM12 6.00002C8.13403 6.00002 5.00002 9.13403 5.00002 13C5.00002 16.866 8.13403 20 12 20C15.866 20 19 16.866 19 13C19 9.13403 15.866 6.00002 12 6.00002ZM3.00002 13C3.00002 8.02946 7.02946 4.00002 12 4.00002C16.9706 4.00002 21 8.02946 21 13C21 17.9706 16.9706 22 12 22C7.02946 22 3.00002 17.9706 3.00002 13ZM12 7.00002C12.5523 7.00002 13 7.44774 13 8.00002V12H17C17.5523 12 18 12.4477 18 13C18 13.5523 17.5523 14 17 14H12C11.4477 14 11 13.5523 11 13V8.00002C11 7.44774 11.4477 7.00002 12 7.00002Z'
        fill={color}
      />
    </svg>
  )
})
